// @flow

import React, { PureComponent } from "react";
import type { RaceTypeCodeEnum, ResultRunner } from "@tvg/types/Race";
import { formatCurrency, formatSequencial } from "@tvg/formatter";
import { get } from "lodash";
import RunnerNumber from "../../_atoms/RunnerNumber";
import {
  PayoffContainer,
  RunnerRow,
  PayoffRow,
  Position,
  JockeySilk,
  JockeySilkContainer,
  Runner,
  Payoff,
  Number
} from "./styled-components";

type Props = {
  runner: ResultRunner,
  raceTypeCode: RaceTypeCodeEnum,
  hasRunner: boolean,
  hasWin: boolean,
  hasPlace: boolean,
  hasShow: boolean,
  showSilks: boolean
};

export default class RacePayoffRunner extends PureComponent<Props> {
  static defaultProps = {
    result: {
      biNumber: 0,
      runnerNumber: "string",
      betAmount: 0,
      finishPosition: 0,
      placePayoff: 0,
      runnerName: "",
      showPayoff: 0,
      winPayoff: 0
    },
    raceTypeCode: "T",
    hasRunner: true,
    hasWin: true,
    hasPlace: true,
    hasShow: true,
    showSilks: false
  };

  renderRunner() {
    const silkUrl = get(this.props, "runner.silkUrl", "");
    const silkUrlSvg = get(this.props, "runner.silkUrlSvg", "");
    const hasSilk = this.props.showSilks && (!!silkUrl || !!silkUrlSvg);

    const renderSilk = <JockeySilk src={silkUrlSvg || silkUrl} alt="Silk" />;

    return (
      <RunnerRow
        key={`position-runner-${this.props.runner.finishPosition}`}
        data-qa-label="raceResultsRunner-runner"
      >
        <Position data-qa-label="raceResultsRunner-runner-position">
          {formatSequencial(this.props.runner.finishPosition)}
        </Position>
        <Number>
          <JockeySilkContainer hasTimeformInfo={hasSilk}>
            {hasSilk && renderSilk}
            <RunnerNumber
              raceTypeCode={this.props.raceTypeCode}
              runnerId={get(this.props, "runner.biNumber")}
              hasTimeformInfo={!!hasSilk}
              isBigSize={!hasSilk}
            />
          </JockeySilkContainer>
        </Number>
        {this.props.hasRunner && (
          <Runner>{get(this.props.runner, "runnerName", "")}</Runner>
        )}
      </RunnerRow>
    );
  }

  renderPayoff() {
    return (
      (this.props.runner.showPayoff > 0 ||
        this.props.runner.winPayoff > 0 ||
        this.props.runner.placePayoff > 0) && (
        <PayoffRow
          key={`payoff-runner-${this.props.runner.finishPosition}`}
          data-qa-label="raceResultsRunner-payoff"
        >
          {this.props.hasWin && (
            <Payoff data-qa-label="raceResultsRunner-payoff-value-win">
              {this.props.runner.winPayoff > 0 &&
                formatCurrency(this.props.runner.winPayoff)}
            </Payoff>
          )}
          {this.props.hasPlace && (
            <Payoff data-qa-label="raceResultsRunner-payoff-value-place">
              {this.props.runner.placePayoff > 0 &&
                formatCurrency(this.props.runner.placePayoff)}
            </Payoff>
          )}
          {this.props.hasShow && (
            <Payoff data-qa-label="raceResultsRunner-payoff-value-show">
              {this.props.runner.showPayoff > 0 &&
                formatCurrency(this.props.runner.showPayoff)}
            </Payoff>
          )}
        </PayoffRow>
      )
    );
  }

  render() {
    return (
      <PayoffContainer showBorder={this.props.hasRunner}>
        {this.renderRunner()}
        {this.renderPayoff()}
      </PayoffContainer>
    );
  }
}
